import styles from './Btn.module.scss';
import cx from 'classnames';

interface IBtn {
  width?: string;
  height?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  bgColor?: string;
  fontColor?: string;
  borderRadius?: string;
  margin?: string;
  fontSize?: string;
  disabled?: boolean;
  visible?: boolean;
  border?: string;
  children: string;
  controlClickOutSide?: React.MutableRefObject<null>;
  BtnIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}
const Btn = ({
  width = '100%',
  height = '48px',
  onClick,
  bgColor = '#000000',
  fontColor = 'white',
  borderRadius = '8px',
  margin,
  fontSize = '16px',
  disabled = false,
  visible = true,
  children,
  border,
  controlClickOutSide,
  BtnIcon,
}: IBtn) => {
  if (!visible) {
    return null;
  }
  return (
    <button
      className={styles.btn}
      ref={controlClickOutSide && controlClickOutSide}
      style={{
        width,
        height,
        backgroundColor: disabled ? '#cecece' : bgColor,
        color: fontColor,
        borderRadius,
        margin,
        fontSize,
        transition: 'all ease 300ms',
        border: border,
        fontWeight: '500',
        letterSpacing: '-1px',
      }}
      disabled={disabled}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {BtnIcon && <BtnIcon />}
      {children}
    </button>
  );
};

export default Btn;
